import React from 'react';
import get from 'lodash/get';

import truncate from 'utils/truncate';

const Tick = (props: any) => (
  <g>
    <text
      width={props.width}
      height={props.height}
      x={props.x}
      y={props.y}
      stroke="none"
      fill="#666"
      textAnchor="middle"
    >
      {get(props, 'payload.value', '').includes(' ') ? (
        <React.Fragment>
          <tspan x={props.x} dy={'0.71em'}>
            {get(props, 'payload.value', '').split(' ')[0]}
          </tspan>
          <tspan x={props.x} dy={'1.42em'}>
            {get(props, 'payload.value', '').split(' ').slice(1).join(' ')}
          </tspan>
        </React.Fragment>
      ) : (
        <tspan x={props.x} dy={'0.71em'}>
          {truncate(get(props, 'payload.value'), 10)}
        </tspan>
      )}
    </text>
  </g>
);

export default Tick;
